import 'arrive'
import $ from 'jquery'

//
//  Actual initiazion
//
document.arrive('.navbar', {existing: true}, function(){

  var $navbar = $(this)
  var button = document.getElementById('navbar-opener');

  //
  //  Open navbar when click the button
  //
  button.addEventListener('click', event => {
    toggleNav()
  })

})

function toggleNav() {

  var $body = $('body')
  var $navbar = $('#navbar')
  var $navbarOverlay = $('#navbar-overlay')
  var $navbarIcon = $('#navbar-opener')
  var $navbarLogo = $('#navbar .logo > a')
  var $boxBackgroundImage = $('.navbar .image-container')

  $('#navbar-overlay').removeClass('has-culture-theme')

  if(!$navbarOverlay.hasClass('opened')){

    $navbarOverlay.addClass('opened')
    $navbarIcon.addClass('opened')
    $body.addClass('navbar-opened')
    $navbar.addClass('navbar-black')
    $navbarLogo.find('.navbar-clear-logo').hide().fadeOut(300)
    $navbarLogo.find('.navbar-dark-logo').show().fadeIn(300)
    $boxBackgroundImage.attr('style','')
    $navbarOverlay.removeClass('white-theme')
    $boxBackgroundImage.removeClass('position-1')
    $boxBackgroundImage.removeClass('position-2')
    $boxBackgroundImage.removeClass('position-3')
    $('.navbar ul.fullscreen-menu li.menu-item ul.sub-menu').removeClass('show')

  } else {
    $navbarOverlay.removeClass('opened')
    $navbarIcon.removeClass('opened')
    $body.removeClass('navbar-opened')

    if($('main').hasClass('set-navbar-white')){
      $navbarLogo.find('.navbar-dark-logo').hide().fadeOut(300)
      $navbar.removeClass('navbar-black')
      $navbar.addClass('navbar-white')
      $navbarLogo.find('.navbar-clear-logo').show().fadeIn(300)
    } else if($('main').hasClass('set-navbar-black')){
      $navbarLogo.find('.navbar-clear-logo').hide().fadeOut(300)
      $navbar.removeClass('navbar-white')
      $navbar.addClass('navbar-black')
      $navbarLogo.find('.navbar-dark-logo').show().fadeIn(300)
    }

  }

}

//
//  Accordion links
//
document.arrive('.main-menu', {existing: true}, function(){

  var $menu = $(this);
  var $levelOneMenuItem = $menu.find('> li.menu-item-has-children > a');
  var $levelSecondMenuItem = $menu.find('> li.menu-item-has-children > .sub-menu > li.menu-item-has-children');

  var $levelOneMenuItemCurrent = $menu.find('> li.current-menu-parent > a');

  $levelOneMenuItem.on('click', function(event){

    event.preventDefault();
    var $currentLevelOneMenuItem = $(this);

    if( !$currentLevelOneMenuItem.parent().hasClass('opened') ){

      $levelOneMenuItem.parent().each(function(){
        $(this).removeClass('opened');
      });

      $currentLevelOneMenuItem.parent().addClass('opened');

    } else {
      $levelOneMenuItem.parent().each(function(){
        $(this).removeClass('opened');
      });
    }

  });
  //
  // $levelSecondMenuItem.hover(function(){
  //   $levelSecondMenuItem.parent().find('.sub-menu').addClass('show-hover');
  // }, function(){
  //   $levelSecondMenuItem.parent().find('.sub-menu').removeClass('show-hover');
  // });

  $levelSecondMenuItem.on('hover', function(){
    $levelSecondMenuItem.parent().find('.sub-menu').addClass('show-hover');
  }, function(){
    $levelSecondMenuItem.parent().find('.sub-menu').removeClass('show-hover');
  });
  //
  //  Auto-open menu
  //
  if($menu.find('.menu-item.active').hasClass('level-1')){
    $menu.find('.menu-item.active').parent().parent().addClass('opened');
  } else if ($menu.find('.menu-item.active').hasClass('level-2')){
    $menu.find('.menu-item.active').parent().addClass('show-hover');
    $menu.find('.menu-item.active').parent().parent().parent().parent().addClass('opened');
  }
});


//
//  Mobile Menu
//

document.arrive('.mobile-menu', {existing: true}, function(){
  var $wrapper = $(this);
  var $existingMenus = $wrapper.find('> ul.mobile-menu-partial');
  var partialMenusContent = '';
  $existingMenus.each(function() {
    partialMenusContent += $(this).html();
  });

  this.innerHTML = '<ul class="mobile-menu-final">' + partialMenusContent + '</ul>';

});

document.arrive('.mobile-menu-final', {existing: true}, function(){

  let $menu = $(this);
  let $levelOneMenuItem = $menu.find('> li.menu-item-has-children > a');
  let $levelSecondMenuItem = $menu.find('> li.menu-item-has-children > .sub-menu > li.menu-item-has-children');
  let $menuItemsNotFirstLevel = $menu.find('> li.menu-item-has-children .sub-menu a');

  $levelOneMenuItem.on('click', function(event){

    event.preventDefault();
    var $currentLevelOneMenuItem = $(this);

    $currentLevelOneMenuItem.find('+ .sub-menu a').removeAttr('tabindex');

    if( !$currentLevelOneMenuItem.parent().hasClass('opened') ){

      $levelOneMenuItem.parent().each(function(){
        $(this).removeClass('opened');
      });

      $currentLevelOneMenuItem.parent().addClass('opened');
      $currentLevelOneMenuItem.find('.sub-menu').css('display', 'block');
      $menu.addClass('has-opened-submenu');
    } else {
      $currentLevelOneMenuItem.find('+ .sub-menu a').attr('tabindex', '-1');
      $levelOneMenuItem.parent().each(function(){
        $(this).removeClass('opened');
      });
      $menu.removeClass('has-opened-submenu');
    }

  });

  $menuItemsNotFirstLevel.each(function() {
    $(this).attr('tabindex', '-1');
  });

  $levelOneMenuItem.each(function() {
    $(this).prepend('<span class="collapse-trigger"><i>-</i></span>');
    $(this).append('<span class="collapse-indicator"><i>-</i></span>');
  });


  $levelSecondMenuItem.on('hover', function(){
    $levelSecondMenuItem.parent().find('.sub-menu').addClass('show-hover');
  }, function(){
    $levelSecondMenuItem.parent().find('.sub-menu').removeClass('show-hover');
  });

  //
  //  Auto-open menu
  //
  if($menu.find('.menu-item.active').hasClass('level-1')){
    $menu.find('.menu-item.active').parent().parent().addClass('opened');
    $menu.addClass('has-opened-submenu');
  }
});